<template>
  <v-main>
    <navigation v-if="!liffUser"/>
    <guide-tour :config-key="`care.${$router.currentRoute.name}`"/>
    <v-card-subtitle class="py-0 grey-7--text">
      訊息排程管理已移至「<router-link :to="{ name: 'CareTemplateSchedule' }" class="link_blue--text">智能個案管理師</router-link>」頁面，<router-link :to="{ name: 'CareTemplateSchedule' }" class="link_blue--text">前往查看</router-link>
    </v-card-subtitle>

    <v-tabs v-model="tab" right>
      <v-tab to="/post-operative-care/progress/unprocessed">待處理</v-tab>
      <v-tab to="/post-operative-care/progress/processed">已處理</v-tab>
    </v-tabs>
    <router-view/>
  </v-main>
</template>

<script>
import Navigation from "@/components/Navigation";
import { mapGetters } from "vuex";
import GuideTour from "@/components/utils/GuideTour.vue";

export default {
  name: "ProgressIndex",
  components: { GuideTour, Navigation },
  computed: {
    ...mapGetters(["liffUser"]),
    tab: {
      get() {
        const path = this.$route.path;
        if (path.includes('/unprocessed')) return 0;
        if (path.includes('/processed')) return 1;
        return 0;
      },
      set() {}
    },
  },
};
</script>
